<template>
  <section v-if="loading" class="mb-8 animate-pulse">
    <div class="h-7 bg-gray-700 rounded w-24 mb-2"></div>
    <div class="masonry col-1 sm:col-2 md:col-4 before:box-inherit after:box-inherit">
      <div v-for="i in 4" :key="i" class="bg-gray-700 rounded mb-4 break-inside" style="height: 200px"></div>
    </div>
  </section>

  <section v-else-if="completeTargets.length || inProgressTargets.length" class="mb-8">
    <h2>Targets</h2>
    <template v-if="completeTargets.length">
      <h3 class="text-sm text-gray-400">Complete</h3>
      <div class="masonry col-1 sm:col-2 md:col-4 before:box-inherit after:box-inherit">
        <TargetCard
          v-for="target in completeTargets"
          :key="target.id"
          :target="target"
          :astronomer-slug="slug"
        />
      </div>
    </template>
    <template v-if="inProgressTargets.length">
      <h3 class="text-sm text-gray-400">In Progress</h3>
      <div class="masonry col-1 sm:col-2 md:col-4 before:box-inherit after:box-inherit">
        <TargetCard
          v-for="target in inProgressTargets"
          :key="target.id"
          :target="target"
          :astronomer-slug="slug"
        />
      </div>
    </template>
  </section>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import TargetCard from './TargetCard.vue'
import { apiFetch } from '../utils/api'

const props = defineProps<{ slug: string }>()

interface Target {
  id: number
  name: string
  image_url: string | null
  last_image_thumbnail: string | null
  last_image_captured_at: string | null
  total_duration: number | null
  complete: boolean
}

const targets = ref<Target[]>([])
const loading = ref(true)

const completeTargets = computed(() => targets.value.filter((t) => t.complete))
const inProgressTargets = computed(() => targets.value.filter((t) => !t.complete))

onMounted(async () => {
  try {
    const data = await apiFetch(`/api/spa/astronomers/${props.slug}/targets`) as { targets: Target[] }
    targets.value = data.targets
  } catch {
    // section stays hidden on failure
  } finally {
    loading.value = false
  }
})
</script>
